import { ValheimCustomSettingsUI } from "./valheimCustomSettingsUI";

export class ValheimCustomSettings {

  private levelType;

  public constructor(private ui: ValheimCustomSettingsUI) {
    this.render();
  }

  private render() {
    this.ui.render().then(() => {
      this.bindEvents();
    });
  }

  private bindEvents() {
    const currentlySelectedMod = this.ui.getValheimModsValue();
    this.ui.handleValheimModChange(currentlySelectedMod);
    this.ui.onModChange(this.ui.handleValheimModChange.bind(this));
  }
}
